import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { removeFromCart } from 'Redux/ducks/cart';
import FluidImg from 'Components/Utility/FluidImg';

import 'Components/PickAndMix/PnmSelectedGameCollapsible.scss';

const PnmSelectedGameCollapsible = ({ selectedProducts, removeFromCart: _removeFromCart }) => {
  const [isOpen, setOpen] = useState(false);

  const onImageClick = productId => _removeFromCart(productId);

  return (
    <section className="PnmSelectedGameCollapsible">
      <button className="PnmSelectedGameCollapsible__button btn-reset-style" onClick={() => setOpen(!isOpen)}>
        <div className="PnmSelectedGameCollapsible__button__text">
          <FormattedMessage
            id="PnmSelectedGameCollapsible.selecteditems"
            defaultMessage="Selected items"
            values={{
              name,
            }}
          />
        </div>
        <div className="PnmSelectedGameCollapsible__button__chevron">
          {isOpen ?
            <FontAwesomeIcon icon={faChevronUp} />
            :
            <FontAwesomeIcon icon={faChevronDown} />
          }
        </div>
      </button>
      {isOpen &&
        <div className="PnmSelectedGameCollapsible__collapsibleSection">
          {isEmpty(selectedProducts) &&
            <b className="text-muted">
              <FormattedMessage
                id="PnmSelectedGameCollapsible.itemsaddedtoyourbundle"
                defaultMessage="items added to your bundle will appear here"
              />
            </b>
          }
          {selectedProducts.map(selectedProduct =>
            <button
              className="btn-reset-style PnmSelectedGameCollapsible__coverImageButton"
              key={selectedProduct.slug}
              onClick={() => onImageClick(selectedProduct._id)}
            >
              <FluidImg
                ratio16by9
                lazy
                className="PnmSelectedGameCollapsible__coverImage img-force-full"
                src={selectedProduct.cover}
                alt={`${selectedProduct.name} in your bundle`}
                folder="product"
              />
              <div className="PnmSelectedGameCollapsible__coverImageOverlay">
                <div className="PnmSelectedGameCollapsible__coverImageBackground">
                  <FontAwesomeIcon icon={faTrashCan} />
                </div>
              </div>
            </button>,
          )}
        </div>
      }
      <div className="PnmSelectedGameCollapsible__divider" />
    </section>
  );
};

PnmSelectedGameCollapsible.propTypes = {
  selectedProducts: PropTypes.arrayOf(PropTypes.object),
};

PnmSelectedGameCollapsible.defaultProps = {
  selectedProducts: [],
};

export default connect(null, { removeFromCart })(PnmSelectedGameCollapsible);
